import { render } from "./BecomeFreeAgent.vue?vue&type=template&id=e2d7ea66&scoped=true"
import script from "./BecomeFreeAgent.vue?vue&type=script&lang=js"
export * from "./BecomeFreeAgent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e2d7ea66"

export default script